<template>
  <div class="social-accounts">
    <el-row style="padding-top: 5px;">
      <el-col :span="8">
        <a href="https://github.com/JakeMa2017" target="_blank">
          <font-awesome-icon
            :icon="['fab', 'github']"
            size="2x"
            style="color: #6e5494;"
          />
        </a>
      </el-col>
      <el-col :span="8">
        <a href="https://jakema-blog.blogspot.com/" target="_blank">
          <font-awesome-icon
            :icon="['fab', 'blogger']"
            size="2x"
            style="color: f57d00;"
          />
        </a>
      </el-col>
      <el-col :span="8">
        <a href="https://www.linkedin.com/in/jakema/" target="_blank">
          <font-awesome-icon
            :icon="['fab', 'linkedin']"
            size="2x"
            style="color: #0072b1;"
          />
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  components: {
    FontAwesomeIcon,
  },
};
</script>

<style scoped>
.social-accounts {
  background-color: white;
  width: 300px;
  height: 40px;
  margin: auto;
  border-radius: 25px;
}
</style>
